module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f929.ffa92fc2.svg";